namespace RedBullMOBILE360.SMSCodes {
    export interface SubscriptionCodesForm {
        OfferId: Serenity.StringEditor;
        OfferName: Serenity.StringEditor;
        IsPrimary: Serenity.IntegerEditor;
        SubscriptionCode: Serenity.StringEditor;
        UnsubscriptionCode: Serenity.StringEditor;
        IsActive: Serenity.IntegerEditor;
        StopAtrnwCode: Serenity.StringEditor;
    }

    export class SubscriptionCodesForm extends Serenity.PrefixedContext {
        static formKey = 'SMSCodes.SubscriptionCodes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SubscriptionCodesForm.init)  {
                SubscriptionCodesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(SubscriptionCodesForm, [
                    'OfferId', w0,
                    'OfferName', w0,
                    'IsPrimary', w1,
                    'SubscriptionCode', w0,
                    'UnsubscriptionCode', w0,
                    'IsActive', w1,
                    'StopAtrnwCode', w0
                ]);
            }
        }
    }
}
